import { useMemo, useState } from "react";
import { TextInput } from "components/Input";
import { assetLabel, SensorView } from "../sensorHealth.utility";

type SensorToolSearchProps = {
  sensors: SensorView[];
  onSelectSensor: (sensor: SensorView) => void;
  onQueryChange: (query: string) => void;
};

export const SensorToolSearch = ({ sensors, onSelectSensor, onQueryChange }: SensorToolSearchProps) => {
  const [query, setQuery] = useState("");

  const matches = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    // Unlinked sensors are excluded from tool search (nothing to match) but remain visible in the grid.
    return sensors.filter((sensor) => sensor.linkedAsset && assetLabel(sensor.linkedAsset).toLowerCase().includes(q));
  }, [query, sensors]);

  const handleChange = (_name: string, value: string) => {
    setQuery(value);
    onQueryChange(value);
  };

  return (
    <div className="relative w-full max-w-md">
      <TextInput
        value={query}
        input={{ name: "sensorSearch", placeholder: "Search by tool name" }}
        onChange={handleChange}
      />
      {query.trim() && (
        <ul className="absolute z-10 mt-1.5 max-h-64 w-full overflow-auto rounded-xl border border-gray-200 bg-white py-1 shadow-lg ring-1 ring-black/5">
          {matches.length === 0 ? (
            <li className="px-3 py-2 text-sm text-gray-500">No tools match &ldquo;{query}&rdquo;.</li>
          ) : (
            matches.map((sensor) => (
              <li key={sensor.key}>
                <button
                  type="button"
                  onClick={() => onSelectSensor(sensor)}
                  className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm hover:bg-gray-50"
                >
                  <span className="truncate font-medium text-gray-900">{assetLabel(sensor.linkedAsset)}</span>
                  <span className="shrink-0 font-mono text-xs tabular-nums text-gray-400">
                    Board {sensor.boardId} · #{sensor.position}
                  </span>
                </button>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};
